<template>
  <div
    id="divDashboardHeader"
    class="container-fluid">
    <div
      id="divDashboardSubheader"
      class="row rd-gridsystem-scrollbar-wrap">
      <div class="rdResponsiveColumn col-lg-8 col-md-8 col-sm-12 col-xs-12 pr-0">
        <h3 v-if="printerFriendly">{{ systemName }}</h3>
        <div
          v-if="showStateImage"
          class="divStateImage"
        >
          <img
            :src="stateImageUrl"
            :alt="stateImageAltText"
          >
        </div>
        <div>
          <h3>{{ GSGo.location }}
            <br>Category: {{ GSGo.category }}
          </h3>
          <div v-if="!printerFriendly">
            <a
              ref="modalLink"
              href="#"
              @click.prevent="showIndicatorModal"
            >Select indicators to view</a>
            ({{ indicators.length }} of {{ maxPossibleIndicatorsCount }} selected)
          </div>
        </div>
      </div>
      <div
        v-if="!printerFriendly"
        class="rdResponsiveColumn col-lg-4 col-md-4 col-sm-12 col-xs-12">
        <div class="linkbucketcontainer">
          <div class="lbspacer"/>
          <SPLinkBucket
            class="linkbucket"
          />
        </div>
      </div>
      <div
        v-if="printerFriendly"
        class="rdResponsiveColumn col-lg-3 col-md-4 col-sm-12 col-xs-12 pl-0 pull-right tr">
        <img
          class="pflogo"
          src="../../assets/Shared.Images.hhs-cdc-logo.png"
          alt="CDC logo">
      </div>
    </div>
    <SPIndicatorsModal
      :indicators="indicators"
      @indicatorsChanged="indicatorsChanged"
      @modalClosed="modalClosed"
    />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import _ from 'lodash';
import SPLinkBucket from './SPLinkBucket';
import SPIndicatorsModal from './SPIndicatorsModal';

export default {
  components: {
    SPLinkBucket,
    SPIndicatorsModal,
  },
  data() {
    return {
      indicators: [],
    };
  },
  computed: {
    ...mapState({
      spgsLink: state => state.spgsLink,
      GSGo: state => state.SP.GSGo,
      goClicked: state => state.SP.flags.goClicked,
      lku: state => state.lku,
      maxPanelCount: state => state.SP.maxPanelCount,
      initialPageLoad: state => state.flags.initialPageLoad,
    }),
    ...mapGetters([
      'printerFriendly',
    ]),
    ...mapGetters('SP', [
      'allPossibleIndicators',
    ]),
    maxPossibleIndicatorsCount() {
      return this.allPossibleIndicators.length;
    },
    locationIndicatorIds() {
      const indicatorIds = _(this.indicators).map('id').value().join(',');
      return `${this.GSGo.locationId},${indicatorIds}`;
    },
    locationAbbr() {
      return this.lku.Location[this.GSGo.locationId].abbr;
    },
    showStateImage() {
      return this.locationAbbr.indexOf('HHS') === -1;
    },
    stateImageUrl() {
      // eslint-disable-next-line
      return require(`./assets/${this.locationAbbr}.png`);
    },
    stateImageAltText() {
      return `Outline for ${this.locationAbbr}`;
    },
    topMaxPanelCountIndicatorsFromAllPossibleIndicators() {
      return _(this.allPossibleIndicators).take(this.maxPanelCount).value();
    },
    systemName() {
      return process.env.SystemName;
    },
  },
  watch: {
    allPossibleIndicators() {
      this.setIndicatorsDefaultSelections();
    },
    locationIndicatorIds() {
      this.getSPDataAndSetIndicators();
    },
  },
  created() {
    this.setIndicatorsDefaultSelections();
    // Moved from SPLinkBucket since this code won't run when the SPLinkBucket is
    // hidden in printerFriendly view which was causing the showFootnotes flag
    // to always be the default of true in the PDF exports #56429
    if (this.initialPageLoad) {
      const showFootnotesQS = this.$route.query.ShowFootnotes;
      if (showFootnotesQS && showFootnotesQS.length && showFootnotesQS === 'false') {
        // QS has show footnotes set to false
        this.$store.commit('SP/setShowFootnotes', false);
      }
    }
  },
  methods: {
    setIndicatorsDefaultSelections() {
      if (this.initialPageLoad) {
        // get csv list of indicators from IndicatorsId query string parm
        let qsIndicatorIds = this.$route.query.IndicatorIds;
        if (qsIndicatorIds) {
          // qs parm was present, convert to an array of id's
          qsIndicatorIds = qsIndicatorIds.split(',');
          // validate the array against possible id's for the global selector selections
          const qsValidIndicatorIds = _.intersection(_(this.allPossibleIndicators).map('id').value(), qsIndicatorIds);
          if (qsValidIndicatorIds.length) {
            // this is at least one valid id in the qs, use the top maxPanelCount values
            this.indicators = _(qsValidIndicatorIds)
              .map(id => this.lku.Question[id])
              .orderBy('sort', 'asc')
              .take(this.maxPanelCount)
              .value();
          } else {
            // none of the qs id's are valid
            this.indicators = this.topMaxPanelCountIndicatorsFromAllPossibleIndicators;
          }
        } else {
          // qs parm was missing
          this.indicators = this.topMaxPanelCountIndicatorsFromAllPossibleIndicators;
        }
      } else {
        // not initial page load
        this.indicators = this.topMaxPanelCountIndicatorsFromAllPossibleIndicators;
      }
    },
    getSPDataAndSetIndicators() {
      this.$store.dispatch('SP/getSPDataAndSetIndicators', this.indicators);
    },
    showIndicatorModal() {
      this.$modal.show('SPIndicatorsModal');
    },
    indicatorsChanged(newIndicators) {
      this.indicators = newIndicators;
    },
    modalClosed() {
      this.$refs.modalLink.focus();
    },
  },
};
</script>

  <style scoped>
    h3 {
      margin: 0;
    }
    .divStateImage {
      float: left;
      padding: 5px;
    }
    @media (min-width: 992px) {
      .linkbucket {
        float: right;
        _display: inline;
      }
    }
    .tr {
      text-align: right;
    }
  </style>



// WEBPACK FOOTER //
// src/components/SP/SPDashboardHeader.vue